export default __webpack_public_path__ + "static/media/elo.124c9075.svg";